import React from 'react';
import ReactDOM from 'react-dom';
import useToastStore from './ToastStore'; // 위에서 만든 zustand 스토어
import styled, { keyframes } from 'styled-components';

const ToastContainer = () => {
  const { toasts, removeToast } = useToastStore();

  return ReactDOM.createPortal(
    <ToastContainerDiv>
      {toasts.map(toast => (
        <ToastDiv key={toast.id} onClick={() => removeToast(toast.id)}>
          {toast.message}
          <ToastSlider>
            <ToastProgress duration={toast.duration} />
          </ToastSlider>
        </ToastDiv>
      ))}
    </ToastContainerDiv>,
    document.getElementById('toast-modal') as HTMLElement
  );
};

export default ToastContainer;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    width: 100%;
  }
  to {
    width: 0;
  }
`;

const ToastContainerDiv = styled.div`
  position: fixed;
  bottom: 20px; /* 화면 하단에서 20px 위에 배치 */
  left: 50%; /* 수평적으로 가운데로 이동 */
  transform: translateX(-50%); /* 수평 중앙 정렬 */
  z-index: 9999; /* 다른 요소 위에 표시되도록 z-index 설정 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px; /* 각 토스트 사이에 간격 추가 */
`;

const ToastDiv = styled.div`
  padding: 15px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  animation: ${fadeInUp} 0.5s ease forwards;
  font-size: 16px;
  ${({ theme }) => ({
    backgroundColor: theme.colors.RG02,
    color: theme.colors.RG00,
  })};
`;
const ToastSlider = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.2);
`;
const ToastProgress = styled.div<{ duration: number }>`
  height: 100%;
  animation-name: ${slideOut};
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  ${({ duration, theme }) => ({
    animationDuration: `${duration}ms`,
    backgroundColor: theme.colors.RG00,
  })};
`;
